import React from 'react';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../CommonComponents/OPL/Modal/ModalHeader';

interface DemoModalProps {
  onClose(): void;
  onBack(): void;
}

export const DemoModal: React.FC<DemoModalProps> = ({ onClose, onBack }) => {
  return (
    <Modal size="large" isOpen onRequestClose={onClose}>
      <ModalHeader>Demo</ModalHeader>

      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <iframe
          src="https://fast.wistia.net/embed/iframe/jk64zxkun8?seo=false"
          title="Orion Planning Overview Video"
          allow="autoplay; fullscreen"
          frameBorder="0"
          scrolling="no"
          className="wistia_embed"
          name="wistia_embed"
          width="752"
          height="423"
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={onBack}>
          Back
        </Button>
      </ModalFooter>
    </Modal>
  );
};
